import $ from "jquery";
import React from 'react';
import {
  Card,
  CardHeader,
  CardText
} from 'material-ui/Card';
import config from '../../config.json';
import auth from '../../auth/auth.react.js';
import DTable from './dist_table.react.js';
import CSSModules from 'react-css-modules';
import styles from './all.css';
import ConfirmDialog from '../../widgets/confirm_dialog.react.js';
import LevelreqDialog from './levelreq_dialog.react.js';

const list_url = config.server + config.api_path + '/dist/'
// const edit_url = config.server + config.api_path + '/admin/user/edit/'
const delete_url = (
  config.server + config.api_path + '/dist/destroy/'
)

const levelreq_url = config.server + config.api_path + '/dist/levelreq'

class AdminDistAllView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect_mode: false
    }

    /* if (props.match && props.match.path.startsWith('/admin/user/edit/') &&
     *   Object.keys(props.match.params)
     *   .length > 0) {
     *   this.state['redirect_mode'] = true
     * }
     */

    this.load_data = this.load_data.bind(this)
    this.open_delete = this.open_delete.bind(this)
    this.open_levelreq = this.open_levelreq.bind(this)
    this.handle_delete = this.handle_delete.bind(this)
    this.handle_levelreq = this.handle_levelreq.bind(this)
    this.refresh_table = this.refresh_table.bind(this)
  }

  componentDidMount() {}

  load_data(rowsPerPage, offset, cb) {
    $.get({
        dataType: 'json',
        url: list_url,
        data: auth.with_session({}, true),
        xhrFields: {
          withCredentials: true
        }
      })
      .done((data) => {
        var _err = data.err
        if (_err && _err.ec === 0) {
          cb(data.ret)
        } else if (_err && _err.ec === 403) {
          this.props.unauthorized()
        }
      })
  }

  refresh_table() {
    this.table.refresh()
  }

  open_delete(data) {
    this.delete_dialog.open_confirm(
      data,
      data.service + ' (' + data.system + ', ' + data.version + ')',
      '/admin/dist/all'
    )
  }

  handle_delete(data, cb) {
    var self = this;
    $.ajax({
        method: 'POST',
        dataType: 'json',
        url: delete_url + data.id,
        data: auth.with_session({}),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          self.refresh_table()
          cb(null)
        } else if (_err && _err.dm === 'not_in') {
          self.props.unauthorized()
        } else if (_err) {
          cb(new Error(_err.em))
        }
      })
  }

  open_levelreq(data) {
    this.levelreq_dialog.open(data)
  }

  handle_levelreq(data, cb) {
    var self = this;
    $.ajax({
        method: 'POST',
        dataType: 'json',
        url: levelreq_url,
        data: auth.with_session(data),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          self.refresh_table()
          cb(null)
        } else if (_err && _err.dm === 'not_in') {
          self.props.unauthorized()
        } else if (_err) {
          cb(new Error(_err.em))
        }
      });
  }

  render() {
    return (
      <Card styleName="admin-card">
        <CardHeader
          title="Dist Packages"
          actAsExpander={false}
          showExpandableButton={false}
        />
        <CardText>
          <ConfirmDialog
            prefix="Delete Package"
            confirm_text="Delete"
            handle_confirm={this.handle_delete}
            history={this.props.history}
            ref={(dialog) => {this.delete_dialog = dialog}}
          />
          <LevelreqDialog
            handle_confirm={this.handle_levelreq}
            history={this.props.history}
            ref={(dialog) => {this.levelreq_dialog = dialog}}
          />
          <DTable
            ref={(table) => {this.table = table}}
            open_delete={this.open_delete}
            open_levelreq={this.open_levelreq}
            load_data={this.load_data}
          >
          </DTable>
        </CardText>
      </Card>
    )
  }
}

AdminDistAllView.defaultProps = {
  data: [],
  deleted: false
}

export default CSSModules(AdminDistAllView, styles)



// WEBPACK FOOTER //
// ./src/views/admin/dist_packages.react.js